import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography, Switch, Chip } from '@mui/material';
import { Settings as SettingsIcon, DirectionsCar as CarIcon } from '@mui/icons-material';

const AdvancedOptionsToggle = ({
  showAdvancedOptions,
  setShowAdvancedOptions,
  showVehicleDetails,
  setShowVehicleDetails
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.8 }}
      style={{
        background: showAdvancedOptions ? 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)' : '#f8f9fa',
        borderRadius: 8,
        border: '1px solid #e0e0e0',
        padding: '12px 16px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: showAdvancedOptions ? 2 : 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <SettingsIcon sx={{ color: '#0284c7', fontSize: 18 }} />
          <Typography variant="body2" fontWeight={600} sx={{ color: '#1e293b', fontSize: '14px' }}>
            Advanced Options
          </Typography>
        </Box>
        
        <Switch
          checked={showAdvancedOptions}
          onChange={(e) => setShowAdvancedOptions(e.target.checked)}
          size="small"
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#16a34a',
              '&:hover': {
                backgroundColor: 'rgba(22, 163, 74, 0.08)',
              },
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: '#16a34a',
            },
            '& .MuiSwitch-track': {
              backgroundColor: '#d1d5db',
            },
            '& .MuiSwitch-thumb': {
              backgroundColor: '#ffffff',
              border: '1px solid #d1d5db',
            },
          }}
        />
      </Box>

      {/* Vehicle Details Toggle (when advanced options are enabled) */}
      {showAdvancedOptions && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            p: 1.5,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: 1,
            border: '1px solid rgba(0, 0, 0, 0.05)'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CarIcon sx={{ color: '#4caf50', fontSize: 16 }} />
              <Typography variant="body2" sx={{ color: '#374151', fontSize: '13px' }}>
                Vehicle Weight Configuration
              </Typography>
              <Chip
                label="2 passengers + 150kg"
                size="small"
                sx={{
                  height: 20,
                  fontSize: '0.7rem',
                  backgroundColor: showVehicleDetails ? '#4caf5020' : '#f3f4f6',
                  color: showVehicleDetails ? '#4caf50' : '#6b7280',
                  border: '1px solid',
                  borderColor: showVehicleDetails ? '#4caf50' : '#d1d5db'
                }}
              />
            </Box>
            
            <Switch
              checked={showVehicleDetails}
              onChange={(e) => setShowVehicleDetails(e.target.checked)}
              size="small"
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: '#4caf50',
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: '#4caf50',
                },
                '& .MuiSwitch-track': {
                  backgroundColor: '#d1d5db',
                },
                '& .MuiSwitch-thumb': {
                  width: 16,
                  height: 16,
                  backgroundColor: '#ffffff',
                  border: '1px solid #d1d5db',
                },
              }}
            />
          </Box>
        </motion.div>
      )}
    </motion.div>
  );
};

export default AdvancedOptionsToggle;
